// Start a finite pulse only when the action enters the visible part of its scroll container.
const states = new WeakMap();
const ACTIVE_CLASS = 'timesheet-attention--active';

function start(element) {
    element.classList.remove(ACTIVE_CLASS);
    if (element.disabled) return;
    // Restart even after a fast exit/re-entry in the same rendering frame.
    void element.offsetWidth;
    element.classList.add(ACTIVE_CLASS);
}

export default {
    inserted(element) {
        const state = {visible: false, disabled: element.disabled, observer: null};
        states.set(element, state);
        if (typeof IntersectionObserver === 'undefined') return;
        state.observer = new IntersectionObserver(entries => {
            if (states.get(element) !== state) return;
            entries.forEach(entry => {
                const visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (visible && !state.visible) start(element);
                if (!visible) element.classList.remove(ACTIVE_CLASS);
                state.visible = visible;
            });
        }, {threshold: [0, 0.5]});
        state.observer.observe(element);
    },
    componentUpdated(element) {
        const state = states.get(element);
        if (!state) return;
        if (element.disabled) element.classList.remove(ACTIVE_CLASS);
        else if (state.disabled && state.visible) start(element);
        state.disabled = element.disabled;
    },
    unbind(element) {
        const state = states.get(element);
        if (state && state.observer) state.observer.disconnect();
        states.delete(element);
        element.classList.remove(ACTIVE_CLASS);
    }
};
